// extracted by mini-css-extract-plugin
export default {"shell":"AppLayout_shell__-Tz6r","content":"AppLayout_content__mtxDa"};